<template>
    <portlet
            :icon="'fad fa-archive'"
            :title="'Ervaringen'"
    >
        <template slot="portletBody">
            <form v-if="Can(rights.EXPERIENCE_ADD)" @submit.prevent="addExperience()">
                <div class="row align-items-end mb-5">
                    <div class="col-sm-8 col-lg-10">
                        <label for="experience-name">Voeg een ervaring toe</label>
                        <input required
                               name="experience-name"
                               id="experience-name"
                               type="text"
                               class="form-control"
                               v-model="name">
                    </div>
                    <div class="col-sm-4 col-lg-2 experience-save">
                        <button class="btn btn-primary btn-block">
                            Toevoegen
                        </button>
                    </div>
                </div>
            </form>
            <datatables
                    :tableClass="tableClass"
                    v-if="getAllExperiences.length && renderedComponent && Can(rights.EXPERIENCE_VIEW)"
                    :rows="getAllExperiences"
                    :columns="columns"
                    tableID="experiences"
                    :tableInitOptions="tableInitOptions"
                    routerLinkClass="dt-router-link"
                    :deleteFunction="deleteExperience"
                    deleteClass="delete"
                    :getDataClass="'get-data'"
                    @rowSelected="rowSelected"
            ></datatables>

            <edit-name-default
                    v-if="experience"
                    :title="'Ervaring aanpassen'"
                    :value="experience"
                    :name="modalId"
                    @saveChanges="editExperience($event)"
            ></edit-name-default>

        </template>
    </portlet>
</template>

<script>
    import {mapGetters} from 'vuex'
    import editNameDefault from '../../components/editNameDefault'
    import {dataTables} from "../../components/mixins/dataTables";
    import {swalModals} from "../../components/mixins/swalModals.js";
    import { Can } from '../../../permission/ability.js';
    import { RIGHTS } from '../roles/rights';

    export default {
        mixins: [dataTables, swalModals],
        components: {editNameDefault},
        data() {
            return {
                rights: '',
                name: '',
                experience: null,
                tableInitOptions: {
                    order: [[1, "desc"]],
                },
                columns: [
                    {data: 'name', name: 'Naam', visible: true, searchable: true, responsivePriority: 1},
                    {
                        data: 'standard', name: 'Standaard', visible: true, searchable: true,
                        render(data) {
                            return (data ? '<i class="fas fa-check"></i>' : '');
                        }
                    },
                    {
                        data: null, name: 'Opties', orderable: false, responsivePriority: 2,
                        render(data) {
                            var options = '';
                            if(Can(RIGHTS.EXPERIENCE_EDIT)) {
                                options += '<i title="Ervaring aanpassen" class="far fa-edit action-icon get-data" data-target="#' + data.id + '" data-toggle="modal"></i>';
                            }

                            if(Can(RIGHTS.EXPERIENCE_DELETE)) {
                                options += '<a class="delete action-icon dt-router-link" data-id="' + data.id + '"><i title="Verwijder" class="far fa-trash-alt delete"></i></a>';
                            }
                            return options;
                        }
                    },
                ],
            }
        },
        methods: {
            Can,
            rowSelected(value) {
                this.modalId = value.id;
                this.experience = {id: this.modalId, name: value.name, standard: value.standard};
            },
            addExperience() {
                let nameExperience = this.name;
                this.$store.dispatch('experiences/set', {name: nameExperience, standard: true, department: this.$store.getters.getUserData.selectedDepartment}).then(() => {
                    this.$toasted.global.successRequest({
                        message: 'Ervaring aangemaakt',
                    });
                    this.name = '';

                    this.renderComponent();
                }).catch(() => {
                    this.$toasted.global.failedRequest();
                })
            },
            editExperience(experience) {
                if (experience.name) {
                    let id = experience.id;

                    $('.modal').modal('hide');
                    $('.modal-backdrop').remove();

                    this.$toasted.global.successRequest({
                        message: 'Ervaring aangepast',
                    });
                    this.$store.dispatch('experiences/set', {
                        id,
                        name: experience.name,
                        standard: experience.standard
                    });

                    this.renderComponent();
                }
            },
            deleteExperience(experience) {
                let id = experience.id;
                this.swalDelete(experience.name).then(result => {
                    if (result.value) {
                        this.$store.dispatch('experiences/delete', id);

                        this.$toasted.global.successRequest({
                            message: 'Ervaring verwijderd',
                        });

                        this.renderComponent();
                    }
                })
            },
        },
        computed: {
            ...mapGetters('experiences', [
                    'getAllExperiences',
                ]
            ),
        },
        created() {
            this.rights = RIGHTS;
        }
    };
</script>